module.exports = __webpack_public_path__ + "01_very_short_gold.26b75d1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_very_short_gold.png
// module id = bQLL
// module chunks = 0